import { Component, OnInit, inject } from '@angular/core';
import {Observable, zip} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {first, map, mergeMap} from 'rxjs/operators';
import {ClientService} from '../../../client/client.service';
import {Client} from '../../../client/client';
import {Diensten} from '../../../dienst/diensten';
import {DienstService} from '../../../dienst/dienst.service';
import {TaakTipAantal} from '../../../tip/taak-tip-aantal';
import {TipService} from '../../../tip/tip.service';
import {AuthService} from '../../../core/auth/auth.service';
import User from '../../../core/auth/user';
import {ZoneService} from '../../../zone/zone.service';
import {Zone} from '../../../zone/zone';

@Component({
    templateUrl: './client-diensten.page.html',
    styleUrls: ['./client-diensten.page.scss'],
    standalone: false
})
export class ClientDienstenPage implements OnInit {
  private authService = inject(AuthService);
  private clientService = inject(ClientService);
  private dienstService = inject(DienstService);
  private zoneService = inject(ZoneService);
  private tipService = inject(TipService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  user$: Observable<User>;
  client$: Observable<Client>;
  diensten$: Observable<Diensten>;
  zones$: Observable<Array<Zone>>;
  taakTipAantallen$: Observable<Array<TaakTipAantal>>;

  ngOnInit(): void {
    this.user$ = this.authService.getUser$();
    this.zones$ = this.zoneService.getZones$();
    this.client$ = this.route.paramMap.pipe(
      map(paramMap => paramMap.get('id')),
      mergeMap(id => this.clientService.getClientById$(id)),
    );
    this.diensten$ = zip(
      this.dienstService.getDiensten$(),
      this.client$,
    )
      .pipe(map(([diensten, client]: [Diensten, Client]) => diensten.filterForClient(client)));
    this.taakTipAantallen$ = this.client$.pipe(
      first(),
      mergeMap(client => this.tipService.getTaakTipAantallen(client.getId()))
    );
  }

  navigateToMeldingen(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/meldingen`);
  }

  navigateToPrestaties(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/prestaties`);
  }

  navigateToClientWijzigen(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/wijzigen`);
  }

  navigateToClientFiche(user: User, client: Client): void {
    if (user.isRegioverantwoordelijke()) {
      this.router.navigateByUrl(`/clienten/${client.getId()}/fiche/beheer`);
    } else {
      this.router.navigateByUrl(`/clienten/${client.getId()}/fiche`);
    }
  }

  navigateToSignaalkaarten(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/signaalkaarten`);
  }

  navigateToClienten(user: User): void {
    user.isTherapeut() ?
      this.router.navigateByUrl(`/clienten/zoeken`)
      : this.router.navigateByUrl(`/clienten`);
  }

  navigateToTips(client: Client, [dienstId, categorieId, taakId]: [string, string, string]): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/tips/dienst/${dienstId}/categorie/${categorieId}/taak/${taakId}`);
  }
}
